var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio active"},[_c('svg',[_c('path',{attrs:{"d":"M2,2 L10,20 L18,10"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }